import React, { useState, useEffect } from 'react';
import get from 'lodash/get';
import useStyles from '../ExploreHotels/style';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import * as locators from './locators';
import SharedSimilarSearchContent from '../../../components/organism/SharedSimilarSearchContent/SharedSimilarSearchContent';
import Box from '../../../components/molecules/Box';
import { getPreProcessedCardListData } from '../ExploreHotels/preProcessData';
import { getPageName, getComponentName } from '../../../utils/getPageComponentInfo';
import { getUId } from '../../../../utils/utility';

const OurRecommendation = props => {
  const classes = useStyles(props);
  const [hasFavouriteBasket, setHasFavouriteBasket] = useState(false);
  const placeholders = get(props.sitecoreContext, 'VADStaticRoute.sitecore.route.placeholders', '');
  const vadHeader = get(placeholders, 'vad-header', []);
  const { params } = props || {};
  const uid = getUId(props)
  useEffect(() => {
    const favouriteBasket = vadHeader.find(item => item.componentName === 'FavoriteBasket');
    const favIsActive = get(favouriteBasket, 'fields["Is Active"].value', false);
    setHasFavouriteBasket(Boolean(favouriteBasket) && favIsActive)
  }, [vadHeader])

  if (!(props.fields && props.fields.title && props.fields.items)) {
    return null;
  }
  const { title, items, subTitle, cta } = props.fields;
  const cardList = getPreProcessedCardListData(items);

  return (
    <Box className={`${classes.root} ourRecommendation`} data-locator={locators.COMPONENT_NAME} uid={uid}>
      <div className='infographicsbgImage-moreLikethis'></div>
      <SharedSimilarSearchContent
        {...{ fields: { cardList, title, description: subTitle, ctaLink: cta, variation: 'MoreLikeThis', aspectRatioNeeded: true, pageName: getPageName(props), componentName: getComponentName(props), forcedRatio: '3x2' } }}
        data-locator={locators.COMPONENT_NAME}
        hasFavouriteBasket={hasFavouriteBasket}
      />
    </Box>
  );
};

export default withErrorBoundary(withSitecoreContext()(OurRecommendation));

